// The client hero's way into a bill: the button and the dialog it opens,
// gated like every other billing write.

import { useState } from "react";
import { useModuleOn } from "../../../api/attorneyConfig";
import type { ClientActionProps } from "../../../components/chrome/screens";
import { NewInvoiceDialog } from "./NewInvoiceDialog";

export function NewInvoiceAction({ lookupKey, fixtures }: ClientActionProps) {
  const [open, setOpen] = useState(false);
  const billingOn = useModuleOn("billing");
  // A prototype client has no matter to bill, and the search behind the
  // dialog would land on somebody real.
  if (fixtures) return null;
  return (
    <>
      {billingOn && (
        <button type="button" className="cc-btn-primary" onClick={() => setOpen(true)}>
          New invoice
        </button>
      )}
      <NewInvoiceDialog
        open={billingOn && open}
        onClose={() => setOpen(false)}
        initialQuery={lookupKey}
      />
    </>
  );
}
